import React, { useState, useContext, useEffect, useRef } from "react";
import Header from "./userheader";
import Footer from "./userfooter";
import toast, { Toaster } from "react-hot-toast";
import CryptoJS from 'crypto-js';
import config from "../../coreFIles/config";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Modal,
  Button
} from "react-bootstrap";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";
import GuestForm from "./GuestForm";
import { bookInit, hotelBooking, priceRecommendation, getBookingDetail } from "../../generalPages/zentrumhub/ZenApi";
import { useNavigate } from 'react-router-dom';
import { facPayment, insertBookingData } from "../../Action/user.action";
import Cookies from "js-cookie";

const loginData = !Cookies.get("loginSuccessPropertyOwner")
  ? []
  : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

const ZenPayment = () => {
  const navigate = useNavigate();
  const { currency } = useContext(CurrencyContext);
  const [show, setShow] = useState(false);
  const [merchantData, setMerchantData] = useState({});
  const [propertyData, setPropertyData] = useState({});
  const [status, setStatus] = useState(false);
  const [guestData, setGuestData] = useState(null);
  const [latestPriceInfo, setLatestPriceInfo] = useState({});
  const [paypalReady, setPaypalReady] = useState(false);
  const [bookingId, setBookingId] = useState()

  const location = window.location;
  const queryParams = new URLSearchParams(location.search);
  const data = queryParams.get('data');
  const guestDataRef = useRef(guestData);
  const bookingRefId = useRef(bookingId)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFacShow = () => setFacShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMerchantData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    guestDataRef.current = guestData;
  }, [guestData]);

  useEffect(() => {
    bookingRefId.current = bookingId;
  }, [bookingId]);

  useEffect(() => {
    const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'your-secret-key-12345';
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    setPropertyData(JSON.parse(decryptedString));
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      if (propertyData?.hotelId) {
        let latestPriceInfo = await priceRecommendation(propertyData);
        setLatestPriceInfo(latestPriceInfo);
        setBookingId(Math.floor(1000 + Math.random() * 9000).toString())

      }
    };
    fetchData();
  }, [propertyData]);

  // PayPal Integration
  useEffect(() => {
    if (propertyData?.selectedRoom?.price > 0) {
      setPaypalReady(true);
    }
  }, [propertyData]);

  const createOrder = (data, actions) => {
    const amount = propertyData?.selectedRoom?.price || 0;
    return actions.order.create({
      purchase_units: [
        {
          description: 'Hotel Booking Payment',
          amount: {
            currency_code: "USD",
            value: amount.toFixed(2),
          },
        },
      ],
    });
  };

  const onApprove = async (data, actions) => {
    try {

      const bookingInitResult = await initateBooking();

      if (!bookingInitResult || bookingInitResult.bookingStatus !== 'Initiated') {
        toast.error('Failed to initiate booking');
        return;
      }
      // Then capture the payment
      const captureData = await actions.order.capture();

      if (captureData.status === "COMPLETED") {
        const bookingResult = await handleBooking();
        if (bookingResult && bookingResult.bookingStatus === 'Confirmed') {
          toast.success('Booking completed successfully!');
          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/hotelbooking`);
          }, 2000);
        } else {
          toast.error('Booking confirmation failed');
        }
      } else {
        toast.error('Payment not completed');
      }
    } catch (error) {
      console.error('Payment processing error:', error);
      toast.error('Error processing payment');
    }
  };

  const onError = (err) => {
    console.error('PayPal error:', err);
    toast.error('Error with PayPal payment');
  };

  const initateBooking = async () => {
    const guestData = guestDataRef.current;
    const booking_id = bookingRefId.current;
    if (!guestData) {
      toast.error('Please fill in guest details first');
      return;
    }

    const bookingData = {
      hotelId: propertyData.hotelId,
      roomId: propertyData.selectedRoom.roomId,
      rateIds: propertyData.selectedRoom.rates[0].id,
      checkin: propertyData.checkin,
      checkout: propertyData.checkout,
      token: propertyData.token,
      guestData: guestData,
      bookingRefId: booking_id,
      bookingFor: 4,
      userId: loginData?.id,
      amount: propertyData?.selectedRoom?.price,
      propertyData: propertyData
    };

    try {
      const res = await bookInit(bookingData);

      return res;
    } catch (error) {
      console.error('Booking init error:', error);
      toast.error('Failed to initiate booking');
      return null;
    }
  };

  const handleBooking = async () => {
    const guestData = guestDataRef.current;
    const bookingId = bookingRefId.current
    if (!guestData) {
      toast.error('Please fill in guest details first');
      return;
    }

    try {
      const bookingData = {
        hotelId: propertyData.hotelId,
        roomId: propertyData.selectedRoom.roomId,
        rateIds: propertyData.selectedRoom.rates[0].id,
        checkin: propertyData.checkin,
        checkout: propertyData.checkout,
        token: propertyData.token,
        guestData: guestData,
        bookingRefId: bookingId,
        bookingFor: 4,
        userId: loginData?.id,
        amount: propertyData?.selectedRoom?.price
      };

      const res = await hotelBooking(bookingData);
      return res;
    } catch (error) {
      console.error('Booking error:', error);
      toast.error('Booking failed');
      return null;
    }
  };

  // FAC Payment Code (unchanged from your original)
  const [Facshow, setFacShow] = useState(false);
  const [checkoutForm, setCheckoutForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    amount: "",
  });

  const [emptyFields, setEmptyFields] = useState([]);
  const handleFacClose = () => {
    setCheckoutForm({})
    setFacShow(false)
    setEmptyFields([])
  };

  const handleFACChange = (e) => {
    const { id, value } = e.target;
    setCheckoutForm({ ...checkoutForm, [id]: value });

    if (emptyFields.includes(id)) {
      setEmptyFields(emptyFields.filter((field) => field !== id));
    }
  };

  const handleFACPayment = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "cardholderName", "cardNumber", "expiryDate", "cvv"];

    const missingFields = requiredFields.filter(
      (field) => !checkoutForm[field] || checkoutForm[field].trim() === ""
    );

    if (missingFields.length > 0) {
      setEmptyFields(missingFields);
      return;
    }

    try {
      let bookingData = {
        hotelId: propertyData.hotelId,
        roomId: propertyData.selectedRoom.roomId,
        rateIds: propertyData.selectedRoom.rates[0].id,
        checkin: propertyData.checkin,
        checkout: propertyData.checkout,
        token: propertyData.token,
        guestData: guestData,
        checkOutDetails: checkoutForm,
        bookingRefId: Math.floor(1000 + Math.random() * 9000).toString(),
        bookingFor: 4,
        propertyData: propertyData,
        userId: loginData?.id,
        amount: propertyData?.selectedRoom?.price
      }
      let res = await bookInit(bookingData);
      if (res.bookingStatus == 'Initiated') {
        let facRes = await facPayment(bookingData)
        if (facRes.data && facRes.data.RedirectData) {
          setCheckoutForm({});
          setFacShow(false);
          setEmptyFields([]);
          const redirectHTML = facRes.data.RedirectData;

          const blob = new Blob([redirectHTML], { type: "text/html" });
          const url = URL.createObjectURL(blob);

          window.location.href = url;
        } else {
          alert("No redirect data received for 3DS authentication.");
        }
      } else {
        toast.error('Failed to initate Payment')
      }
    } catch (error) {
      console.error("Error during FAC payment:", error);
    }
  };

  return (
    <>
      <Header />
      <div>
        <Toaster />
        <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
          <Container>
            <div className="">
              <Row className=" ">
                <Col lg={7} className="mb-4">
                  {typeof propertyData.roomCount !== 'undefined' && (
                    <GuestForm
                      onStatusChange={(status) => setStatus(status)}
                      onSubmitFormData={(data) => setGuestData(data)}
                      noOfRoomBooked={propertyData.roomCount}
                    />
                  )}
                  <div className="p-3">
                    <div className="heading border-bottom border-secondary pt-2 pb-2">
                      <h5><b>Payment</b></h5>
                    </div>
                    <div className="mt-4">
                      <h6 className="mb-2"><b>Pay With:</b></h6>
                    </div>

                    {/* <button
                      style={{ backgroundColor: '#007bff', color: 'white' }}
                      className="d-flex align-items-center fw-bold justify-content-center btn w-100 mt-2"
                      onClick={handleFacShow}
                    >
                      Credit / Debit Card
                    </button>
                    <br /> */}

                    {/* <button
                      style={{ backgroundColor: '#007bff', color: 'white' }}
                      className="d-flex align-items-center fw-bold justify-content-center btn w-100 mt-2"
                      onClick={handleBooking}
                    >
                      Booking
                    </button>
                    <br /> */}

                    {paypalReady && (
                      <PayPalScriptProvider
                        options={{
                          "client-id": config.CLIENT_ID,
                          "currency": "USD",
                          "intent": "capture"
                        }}
                      >
                        <PayPalButtons
                          style={{ layout: "vertical" }}
                          createOrder={createOrder}
                          onApprove={onApprove}
                          onError={onError}
                          fundingSource={FUNDING.PAYPAL}
                          disabled={!guestData}
                        />
                      </PayPalScriptProvider>
                    )}

                  </div>
                </Col>

                <Col lg={5} className="mb-4">
                  <Card>
                    <div className="paymentImg">
                      {propertyData?.selectedRoom?.images?.length > 0 && (
                        <img
                          src={propertyData.selectedRoom.images[0].fileNameImage}
                          alt={propertyData.selectedRoom.roomName || "Room Image"}
                          className="img-fluid"
                        />
                      )}
                    </div>
                    <div className="px-2">
                      <div className="mt-4">
                        <div>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="fw-bold mb-0">{propertyData.hotelName}</h5>
                            <h6
                              className={`fw-bold mb-0 ${propertyData.selectedRoom?.refundable ? 'text-success' : 'text-danger'
                                }`}
                            >
                              {propertyData.selectedRoom?.refundable ? 'Refundable' : 'Non-Refundable'}
                            </h6>
                          </div>
                          <h6 className="mb-0">{propertyData.address}</h6>
                        </div>
                      </div>
                      <hr />
                      <div className="">
                        <Row>
                          <Col lg={6}>
                            <div>
                              <div><b>Check-in</b></div>
                              <p className="text-grey mb-0">{propertyData?.checkin || "N/A"}</p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Checkout</b></div>
                              <p className="text-grey mb-0">{propertyData?.checkout || "N/A"}</p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Rooms</b></div>
                              <p className="text-grey mb-0">
                                {propertyData?.selectedRoom?.rates?.[0]?.occupancies?.length || 0} Rooms
                              </p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Guests</b></div>
                              <p className="text-grey mb-0">
                                {(() => {
                                  const occ = propertyData?.selectedRoom?.rates?.[0]?.occupancies || [];
                                  const totalAdults = occ.reduce((sum, o) => sum + parseInt(o.numOfAdults || 0), 0);
                                  return `${totalAdults} Adults`;
                                })()}
                              </p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Children</b></div>
                              <p className="text-grey mb-0">
                                {(() => {
                                  const occ = propertyData?.selectedRoom?.rates?.[0]?.occupancies || [];
                                  const totalChildren = occ.reduce((sum, o) => sum + parseInt(o.numOfChildren || 0), 0);
                                  return `${totalChildren} Children`;
                                })()}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <hr />
                      <div className="mt-4 mb-1">
                        <Row>
                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h6>Booking Amount</h6>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <span className="text-grey">
                              + ${propertyData?.selectedRoom?.basePrice} {currency}
                            </span>
                          </Col>

                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h6>Taxes & Other Charges</h6>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <span className="text-grey">
                              + ${propertyData?.selectedRoom?.taxAmt} {currency}
                            </span>
                          </Col>

                          <Col lg={6} sm={6} xs={6} className="mb-2 ">
                            <h5><b>Total Cost:</b></h5>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <h5 className="fw-bold">
                              ${propertyData?.selectedRoom?.price} {currency}
                            </h5>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </div>

      {/* Merchant Payment Modal */}
      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header closeButton className="border-0 position-relative z-2">
        </Modal.Header>
        <Modal.Body style={{ marginTop: "-38px" }}>
          <div className="text-center mb-3">
            <div className="mb-2">
              <img
                src="images/mmg-logo.png"
                alt="MMG Logo"
                style={{ height: "50px" }}
              />
            </div>
            <h4 className="fw-semibold mb-2">Initiate Payment</h4>
            <h6 className="fw-semibold mb-2">Property Nu</h6>
          </div>
          <div>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Customer MMG Number</Form.Label>
                <Form.Control
                  type="text"
                  id="customerId"
                  name="customerId"
                  placeholder="MMG Number"
                  value={merchantData.customerId}
                  onChange={handleChange}
                  className="rounded-1"
                />
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="primary"
                  onClick={() => { }}
                  className="rounded-1"
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Fac Modal */}
      <Modal show={Facshow} onHide={handleFacClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold lh-1"><div>Checkout form</div> <span className="x-small h5">Please fill out the form below to complete your purchase.</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="cardholderName">
                  <Form.Label>Cardholder Name</Form.Label>
                  <Form.Control type="text"
                    placeholder="Enter name"
                    id="cardholderName"
                    value={checkoutForm.cardholderName}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("cardholderName") ? "red" : "" }} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="cardNumber">
                  <Form.Label>Card Number</Form.Label>
                  <Form.Control type="text"
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                    id="cardNumber"
                    onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                    value={checkoutForm.cardNumber}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("cardNumber") ? "red" : "" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="expiryDate">
                  <Form.Label>Expiration Date (YYMM)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="YY / MM"
                    id="expiryDate"
                    onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                    value={checkoutForm.expiryDate}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("expiryDate") ? "red" : "" }}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="cvv">
                  <Form.Label>Security Code (CVV2)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="XXX"
                    id="cvv"
                    onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                    value={checkoutForm.cvv}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("cvv") ? "red" : "" }} />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="amount">
                  <Form.Label>Amount to pay</Form.Label>
                  <Form.Control
                    type="Number"
                    placeholder="e.g. 100.00 USD"
                    id="amount"
                    value={parseFloat(propertyData?.selectedRoom?.price) > 0 ? parseFloat(propertyData?.selectedRoom?.price).toFixed(2) : ""}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button variant="primary" type="button" className="w-100" onClick={handleFACPayment}>
              Confirm Payment
            </Button>

            <div className="text-center mt-4">
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" height="30" className="mx-2" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="MasterCard" height="30" className="mx-2" />
              <img src="images/american_exp.webp" alt="AMEX" height="30" className="mx-2" />
            </div>

            <div className="text-center mt-2 text-muted" style={{ fontSize: '14px' }}>
              <p>
                POWERED BY <img src="images/Powertranz-Logo.png" alt="PowerTranz" style={{ height: '23px', verticalAlign: 'middle' }} />
              </p>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default ZenPayment;